module.exports = __webpack_public_path__ + "cucumber.jpg?eb5a6bef631280a30267b0673d3d25c6";